import UrlHelper from "./url-helper"

const REACT_APP_IOS_BUNDLE_ID = "com.thekinapp"
export const REACT_APP_PACKAGE_NAME = "com.thekinapp.prod"
const REACT_APP_DYNAMIC_LINK_DOMAIN = "kinapp.page.link"
const REACT_APP_IOS_APP_ID = "1437611153"
const REACT_APP_FALLBACK_LINK = "https://apps.apple.com/za/app/kin/id1437611153"

/**
 * Class used to build dynamic links for play store and app store
 *
 * @class DynamicLinkBuilder
 */
class DynamicLinkBuilder {
  static buildLink(url) {
    const isAndroid = url.indexOf("play.google.com") >= 0

    let currentPage = "https://thekinapp.com"

    currentPage = UrlHelper.appendQueryString(
      currentPage,
      "anid",
      DynamicLinkBuilder.getSegmentAnon()
    )
    console.log(url, currentPage)
    if (isAndroid) {
      url = UrlHelper.appendQueryString(url, "url", currentPage)
    } else {
      url = `https://${REACT_APP_DYNAMIC_LINK_DOMAIN}/`
      url = UrlHelper.appendQueryString(url, "link", currentPage)
      url = UrlHelper.appendQueryString(url, "apn", REACT_APP_PACKAGE_NAME)
      url = UrlHelper.appendQueryString(url, "ibi", REACT_APP_IOS_BUNDLE_ID)
      url = UrlHelper.appendQueryString(url, "isi", REACT_APP_IOS_APP_ID)
      url = UrlHelper.appendQueryString(url, "ofl", REACT_APP_FALLBACK_LINK)
      url = UrlHelper.appendQueryString(url, "efr", "1")
    }
    return url
  }

  static safeReadCookie() {
    var cookie
    try {
      cookie = document.cookie
    } catch (err) {
      if (
        typeof console !== "undefined" &&
        typeof console.error === "function"
      ) {
        console.error(err.stack || err)
      }
      cookie = ""
    }
    return cookie
  }

  static getSegmentAnon() {
    var cookie = DynamicLinkBuilder.safeReadCookie()
    const name = "ajs_anonymous_id"
    var value =
      cookie
        .split(";")
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, name.length + 1) === `${name}=`
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(name.length + 1))
        })
        .map(url => url.replace(/"/g, ""))[0] || null
    return value
  }
}

export default DynamicLinkBuilder
